import type { ComponentProps } from 'preact/compat';

import type EmojiPicker from 'emoji-picker-react';
import { Categories } from 'emoji-picker-react';
import emojiDataRuJson from 'emoji-picker-react/dist/data/emojis-ru.json';

export const EMOJI_CATEGORIES = [
  Categories.SMILEYS_PEOPLE,
  Categories.ANIMALS_NATURE,
  Categories.FOOD_DRINK,
  Categories.TRAVEL_PLACES,
  Categories.ACTIVITIES,
  Categories.OBJECTS,
  Categories.SYMBOLS,
  Categories.FLAGS,
] as const;

export const EMOJI_CATEGORY_NAMES_EN: Record<(typeof EMOJI_CATEGORIES)[number], string> = {
  [Categories.SMILEYS_PEOPLE]: 'Smileys & People',
  [Categories.ANIMALS_NATURE]: 'Animals & Nature',
  [Categories.FOOD_DRINK]: 'Food & Drink',
  [Categories.TRAVEL_PLACES]: 'Travel & Places',
  [Categories.ACTIVITIES]: 'Activities',
  [Categories.OBJECTS]: 'Objects',
  [Categories.SYMBOLS]: 'Symbols',
  [Categories.FLAGS]: 'Flags',
};

export const emojiDataRu = emojiDataRuJson as NonNullable<ComponentProps<typeof EmojiPicker>['emojiData']>;
